import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Button, Typography, Box } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import { fetchAddCameraInfo } from "../AddSite/fetchAddCameraInfo";
import { StatusNotificationScreen } from "../../common/StatusNotificationScreen";
import { handleNavigateToSitesPage } from "./handleNavigateToSitesPage";
import ErrorBoundary from "../../../ErrorBoundary";
import { integrationsMatcher } from "../../utils/integrationsMatcher";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { isCameraCheckSupported } from "./isCameraCheckSupported";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export { isCameraCheckSupported };

export const OnboardingProgressDiv = ({
  percentage,
  step,
  setVisibleScreen,
}: {
  percentage: number;
  step: number;
  setVisibleScreen: any;
}) => {
  const navigate = useNavigate();
  const isOnvifWireguard =
    localStorage.selectedIntegrationName === "onvif_wireguard";

  const [activeOnboardingScreen, setActiveOnboardingScreen] = React.useState(
    <></>
  );

  const validCameraCheckIntegration = isCameraCheckSupported();

  React.useEffect(() => {
    setActiveOnboardingScreen(onboardingScreen);
  }, []);

  const onvifOnboardingScreen = (
    <ErrorBoundary>
      <div>
        <ThemeProvider theme={theme}>
          <div className="absolute top-[142px] right-44">
            <LinearProgress
              color="primary"
              variant="determinate"
              value={percentage}
              sx={{ width: 275 }}
            />
          </div>
          <div className="absolute top-32 right-32">
            <Typography variant="body1">{percentage}%</Typography>
          </div>
          <div className="absolute top-[195px] right-[150px] font-mulish text-actuate-blue">
            <p> Please complete the following information. </p>
          </div>
          <div className="absolute top-[220px] right-[190px] font-mulish text-actuate-blue">
            <p> Otherwise the site won&apos;t run.</p>
          </div>
          <div className="absolute top-[275px] right-[350px]">
            <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
              <FormControlLabel
                sx={{
                  fontFamily: "Mulish",
                  color: "#001943",
                }}
                label="Site Creation"
                control={<Checkbox color="primary" checked={true} />}
              />
              <br></br>
              <FormControlLabel
                sx={{
                  fontFamily: "Mulish",
                  color: "#001943",
                }}
                label="Camera Setup"
                control={<Checkbox color="primary" checked={step > 1} />}
              />
              <br></br>
              <FormControlLabel
                sx={{
                  fontFamily: "Mulish",
                  color: "#001943",
                }}
                label="Schedule Setup"
                control={<Checkbox color="primary" checked={step > 2} />}
              />
            </Box>
          </div>
          {step === 1 && (
            <div className="absolute top-[346px] right-24">
              <OrangeTextButton
                disabled={false}
                text="Discover Cameras"
                onClick={() => {
                  navigate(`/sites/${localStorage.siteId}/onvifdiscovery`);
                }}
              />
            </div>
          )}
          {step === 2 && (
            <div className="absolute top-[411px] right-24">
              <Button
                color="primary"
                onClick={() => {
                  navigate("/sites/addschedule");
                  localStorage.setItem("cameraNumber", "1");
                }}
              >
                + Add Schedule
              </Button>
            </div>
          )}
        </ThemeProvider>
      </div>
    </ErrorBoundary>
  );

  const onboardingScreen = isOnvifWireguard ? (
    onvifOnboardingScreen
  ) : (
    <ErrorBoundary>
      <div>
        <ThemeProvider theme={theme}>
          <div className="absolute top-[142px] right-44">
            <LinearProgress
              color="primary"
              variant="determinate"
              value={percentage}
              sx={{ width: 275 }}
            />
          </div>
          <div className="absolute top-32 right-32">
            <Typography variant="body1">{percentage}%</Typography>
          </div>
          <div className="absolute top-[195px] right-[150px] font-mulish text-actuate-blue">
            <p> Please complete the following information. </p>
          </div>
          <div className="absolute top-[220px] right-[190px] font-mulish text-actuate-blue">
            <p> Otherwise the site won&apos;t run.</p>
          </div>
          <div className="absolute top-[275px] right-[350px]">
            <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
              <FormControlLabel
                sx={{
                  fontFamily: "Mulish",
                  color: "#001943",
                }}
                label="Site Creation"
                control={<Checkbox color="primary" checked={true} />}
              />
              <br></br>
              <FormControlLabel
                sx={{
                  fontFamily: "Mulish",
                  color: "#001943",
                }}
                label="Camera Setup"
                control={<Checkbox color="primary" checked={step > 1} />}
              />
              <br></br>
              {localStorage.healthcheckOnly === "false" &&
                localStorage.healthMonitoringOnly === "false" && (
                  <FormControlLabel
                    label="Schedule Setup"
                    control={<Checkbox color="primary" checked={step > 2} />}
                  />
                )}
              {validCameraCheckIntegration &&
                localStorage.healthMonitoringOnly === "true" && (
                  <FormControlLabel
                    label="Check Cameras"
                    control={<Checkbox color="primary" checked={false} />}
                  />
                )}

              <br></br>
              {validCameraCheckIntegration &&
                localStorage.healthMonitoringOnly === "false" && (
                  <FormControlLabel
                    label="Check Cameras"
                    control={<Checkbox color="primary" checked={false} />}
                  />
                )}
            </Box>
          </div>
          {step === 1 && (
            <div className="absolute top-[346px] right-24">
              <Button
                color="primary"
                onClick={() => {
                  localStorage.removeItem("addAdditionalCamera");
                  localStorage.setItem("clickedFromSiteAboutPage", "false");
                  if (localStorage.autoAdd === "false") {
                    localStorage.setItem("firstCameraAdded", "true");
                    localStorage.setItem("copyValues", "true");
                    navigate("/sites/addcamera");
                    localStorage.setItem("cameraNumber", "1");
                  } else {
                    setActiveOnboardingScreen(camerasLoadingScreen);
                    fetchAddCameraInfo(
                      localStorage.siteId,
                      setVisibleScreen,
                      navigate
                    );
                  }
                }}
              >
                + Add Camera
              </Button>
            </div>
          )}
          {localStorage.healthcheckOnly === "false" &&
            localStorage.healthMonitoringOnly === "false" &&
            step < 3 && (
              <div className="absolute top-[411px] right-24">
                <Button
                  color="primary"
                  disabled={step !== 2}
                  onClick={() => {
                    navigate("/sites/addschedule");
                    localStorage.setItem("cameraNumber", "1");
                  }}
                >
                  + Add Schedule
                </Button>
              </div>
            )}
          {validCameraCheckIntegration &&
            localStorage.healthMonitoringOnly === "true" && (
              <div className={"absolute top-[411px] right-24"}>
                <Button
                  color="primary"
                  disabled={step !== 2}
                  onClick={() => {
                    localStorage.setItem("healthMonitoringOnly", "false");
                    localStorage.setItem("cameraCheckAlertOpen", "true");
                    localStorage.setItem("clickedId", localStorage.siteId);
                    handleNavigateToSitesPage(navigate);
                    localStorage.setItem("navigatedFromSitesAboutPage", "true");
                    localStorage.setItem("level0Click", "true");
                  }}
                >
                  TEST CAMERAS
                </Button>
              </div>
            )}
          {validCameraCheckIntegration &&
            localStorage.healthMonitoringOnly === "false" && (
              <div
                className={
                  localStorage.healthcheckOnly === "false"
                    ? "absolute top-[474px] right-24"
                    : "absolute top-[411px] right-24"
                }
              >
                <Button
                  color="primary"
                  disabled={step !== 3}
                  onClick={() => {
                    localStorage.setItem("cameraCheckAlertOpen", "true");
                    localStorage.setItem("clickedId", localStorage.siteId);
                    handleNavigateToSitesPage(navigate);
                    localStorage.setItem("navigatedFromSitesAboutPage", "true");
                    localStorage.setItem("level0Click", "true");
                  }}
                >
                  TEST CAMERAS
                </Button>
              </div>
            )}
        </ThemeProvider>
      </div>
    </ErrorBoundary>
  );

  const camerasLoadingScreen = (
    <StatusNotificationScreen
      styling="absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80"
      text={
        <p>
          Fetching cameras.
          <br />
          {integrationsMatcher(localStorage.integrationType, "Id") ===
          "hikcentral"
            ? `This might take a few seconds.`
            : `This might take a few minutes.`}
        </p>
      }
    />
  );

  return <div>{activeOnboardingScreen}</div>;
};
